import React from "react";
import { Container, Row, Col, Card, Image, ListGroup } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const NotepadShortcuts = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 shadow mb-3">
          <h1>Supercharge Your Workflow with Notepad++ Shortcuts</h1>
          <span className="small text-muted"><b>Publish By: </b>CodeInputs</span>

          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image
                src="/graphics/images/notepad++_shortcuts.png"
                alt="Notepad++ Shortcuts"
                fluid
              />
            </Col>
          </Row><br/>

          <p className="mt-4 text-dark">
            Notepad++ is a powerful and feature-rich text and source code editor that provides various functionalities to enhance productivity. One of the best ways to improve efficiency and streamline tasks is by using shortcut keys. These shortcuts help you perform common operations quickly without relying on a mouse. In this guide, we will explore the essential Notepad++ shortcut keys that every user should know to optimize their workflow.
          </p>

          {/* Shortcut Sections */}
          <ul>
              <li class="blacktext mt-3"><b>Ctrl + C</b> – Copies the selected text to the clipboard so it can be pasted elsewhere.</li>

              <li class="blacktext mt-3"><b>Ctrl + X</b> – Cuts the selected text and saves it to the clipboard for pasting.</li>

              <li class="blacktext mt-3"><b>Ctrl + V</b> – Pastes the copied or cut text at the cursor position.</li>

              <li class="blacktext mt-3"><b>Ctrl + Z</b> – Undoes the last action, allowing you to revert changes.</li>

              <li class="blacktext mt-3"><b>Ctrl + Y</b> – Redoes the last undone action, restoring the previous edit.</li>

              <li class="blacktext mt-3"><b>Ctrl + A</b> – Selects all text in the document, making it easy to copy or format everything at once.</li>

              <li class="blacktext mt-3"><b>Ctrl + D</b> – Duplicates the current line, creating an identical copy below.</li>

              <li class="blacktext mt-3"><b>Ctrl + L</b> – Deletes the entire line where the cursor is currently positioned.</li>
            </ul>

          <h5>Navigation Shortcut Keys</h5>

            <ul>
              <li class="blacktext mt-3"><b>Ctrl + Home</b> – Moves the cursor to the beginning of the document for quick access.</li>

              <li class="blacktext mt-3"><b>Ctrl + End</b> – Moves the cursor to the end of the document.</li>

              <li class="blacktext mt-3"><b>Ctrl + G</b> – Opens the "Go to Line" dialog, allowing you to jump directly to a specific line number.</li>

              <li class="blacktext mt-3"><b>Ctrl + F</b> – Opens the "Find" dialog to search for text within the document.</li>

              <li class="blacktext mt-3"><b>Ctrl + H</b> – Opens the "Replace" dialog to find and replace specific words or characters.</li>

              <li class="blacktext mt-3"><b>Ctrl + Shift + Up/Down</b> – Moves the current line of text up or down within the document, useful for rearranging code or text.</li>
            </ul>

            <h5>File Management Shortcut Keys</h5>

            <ul>
              <li class="blacktext mt-3"><b>Ctrl + N</b> – Creates a new document, opening a blank workspace.</li>

              <li class="blacktext mt-3"><b>Ctrl + O</b> – Opens an existing file from your system.</li>

              <li class="blacktext mt-3"><b>Ctrl + S</b> – Saves the current file, preventing data loss.</li>

              <li class="blacktext mt-3"><b>Ctrl + Shift + S</b> – Saves the file with a new name or location (Save As).</li>

              <li class="blacktext mt-3"><b>Ctrl + P</b> – Prints the current document.</li>

              <li class="blacktext mt-3"><b>Ctrl + W</b> – Closes the currently open document.</li>

              <li class="blacktext mt-3"><b>Ctrl + Shift + N</b> – Opens a new instance of Notepad++, allowing multiple windows.</li>
            </ul>

            <h5>Search and Replace Shortcut Keys</h5>

            <ul>
              <li class="blacktext mt-3"><b>F3</b> – Finds the next occurrence of the searched text.</li>

              <li class="blacktext mt-3"><b>Shift + F3</b> – Finds the previous occurrence of the searched text.</li>

              <li class="blacktext mt-3"><b>Ctrl + F3</b> – Finds the next occurrence of the currently selected text.</li>

              <li class="blacktext mt-3"><b>Ctrl + Shift + F3</b> – Finds the previous occurrence of the selected text.</li>

              <li class="blacktext mt-3"><b>Ctrl + H</b> – Opens the "Replace" dialog for find and replace operations.</li>

              <li class="blacktext mt-3"><b>Ctrl + Shift + R</b> – Records a macro for repetitive tasks, which can be played back later.</li>
            </ul>

            <h5>Code Editing Shortcut Keys</h5>

            <ul>
              <li class="blacktext mt-3"><b>Ctrl + Shift + L</b> – Converts the selected text to lowercase.</li>

              <li class="blacktext mt-3"><b>Ctrl + Shift + U</b> – Converts the selected text to uppercase.</li>

              <li class="blacktext mt-3"><b>Ctrl + Q</b> – Toggles a single-line comment on/off, useful for quickly commenting out code.</li>

              <li class="blacktext mt-3"><b>Ctrl + Shift + Q</b> – Toggles a block comment on/off, wrapping multiple lines in comment tags.</li>

              <li class="blacktext mt-3"><b>Tab</b> – Indents the current line of text, improving readability in code.</li>

              <li class="blacktext mt-3"><b>Shift + Tab</b> – Reduces indentation for the current line, aligning text or code properly.</li>
            </ul>

            <h5>Tab and Window Management Shortcut Keys</h5>

            <ul>
              <li class="blacktext mt-3"><b>Ctrl + Tab</b> – Switches between open documents in Notepad++.</li>

              <li class="blacktext mt-3"><b>Ctrl + Shift + Tab</b> – Switches to the previously opened document.</li>

              <li class="blacktext mt-3"><b>Ctrl + T</b> – Swaps the current line with the next one, useful for reordering content.</li>

              <li class="blacktext mt-3"><b>Alt + F4</b> – Closes the Notepad++ application entirely.</li>
            </ul>

            <h5>Bonus Productivity Shortcut Keys</h5>

            <ul>
              <li class="blacktext mt-3"><b>Ctrl + B</b> – Toggles a bookmark on/off at the current line, marking important sections.</li>

              <li class="blacktext mt-3"><b>F2</b> – Moves to the next bookmarked line for quick navigation.</li>

              <li class="blacktext mt-3"><b>Shift + F2</b> – Moves to the previous bookmarked line.</li>

              <li class="blacktext mt-3"><b>Ctrl + Space</b> – Activates auto-completion for code or text, speeding up typing.</li>

            </ul>

          <h4>Conclusion</h4>

            <p class="mt-4 blacktext">Mastering Notepad++ shortcut keys can significantly enhance your workflow, making coding, text editing, and file management more efficient. Whether you are a developer, writer, or casual user, these shortcuts allow you to perform tasks more quickly and effectively. Incorporate these shortcut keys into your daily usage and experience an optimized and productive Notepad++ experience!</p>

            <h4 class="mt-4 blacktext">Some More Blogs related to Notepad++</h4>
          <a href="<?php echo base_url();?>notepadplus.html" class="text-orange">Boost Your Coding Efficiency with Notepad++</a><br/><br/>
          <a href="<?php echo base_url();?>notepad_plugins.html" class="text-orange">Top Notepad++ Plugins to Boost Productivity and Efficiency</a>
        </Col>

        <Col sm={3}>
          <Card className="mb-3 shadow">
            <Card.Body>
              <h4 className="head-color">Recent Post</h4>
              <RecentPost/>
            </Card.Body>
          </Card>

          <Card className="shadow">
            <Card.Body>
              <h4 className="head-color">Recent Comment</h4>
              <p>No Comments to Show</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

const renderShortcutSection = (title, shortcuts) => (
  <>
    <h5 className="mt-4 text-dark">{title}</h5>
    <ListGroup>
      {shortcuts.map(([shortcut, description], index) => (
        <ListGroup.Item key={index}>
          <b>{shortcut}</b> – {description}
        </ListGroup.Item>
      ))}
    </ListGroup>
  </>
);

export default NotepadShortcuts;